import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Button, List, ListItem, Notice } from '@sauda/ui/kit';
import { api } from '../lib/api.js';
import { formatIst } from '../lib/time.js';
import type { InboxMessage } from '../lib/types.js';

/** Development only: what the fake WhatsApp adapter sent. Not part of a production build. */
export function DevInboxScreen() {
  const { t } = useTranslation();
  const inbox = useQuery({
    queryKey: ['dev-inbox'],
    queryFn: () => api<InboxMessage[]>('/dev/inbox', { auth: false }),
    refetchInterval: 3000,
  });
  return (
    <main className="admin-login">
      <div className="form-stack">
        <h1 className="k-t-headline">{t('dev.inboxTitle')}</h1>
        <Notice tone="info">{t('dev.inboxNote')}</Notice>
        <div>
          <Button variant="tonal" onClick={() => void inbox.refetch()}>
            {t('dev.refresh')}
          </Button>
        </div>
        {inbox.isError ? <Notice tone="error">{t('dev.inboxError')}</Notice> : null}
        {inbox.data?.length === 0 ? (
          <p className="k-t-body k-muted">{t('dev.inboxEmpty')}</p>
        ) : null}
        <List label={t('dev.inboxTitle')}>
          {(inbox.data ?? []).map((m) => (
            <ListItem
              key={m.id}
              title={m.text}
              supporting={`${m.to} · ${m.template} · ${formatIst(m.createdAt)}`}
            />
          ))}
        </List>
      </div>
    </main>
  );
}
